export default function saveRow(dataSource, row, setData) {
  if (row.id == null) return;
  const newData = JSON.parse(JSON.stringify(dataSource));
  const index = newData.findIndex((item) => item.id === row.id);
  if (index === -1) return;
  newData[index] = { ...row };
  setData(newData);
}
